import React from "react";

interface ArrowUpDownSplitProps {
  size?: number;
  strokeWidth?: number;
  upColor?: string;
  downColor?: string;
}

export const ArrowUpDownSplit: React.FC<ArrowUpDownSplitProps> = ({ size = 16, strokeWidth = 2, upColor = "currentColor", downColor = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg"  width={size} height={size} viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
    
    {/* Down arrow group */}
    <g stroke={downColor} strokeWidth={strokeWidth}>
      <path d="m21 16-4 4-4-4" />
      <path d="M17 20V4" />
    </g>

    {/* Up arrow group */}
    <g stroke={upColor} strokeWidth={strokeWidth}>
      <path d="m3 8 4-4 4 4" />
      <path d="M7 4v16" />
    </g>
    
  </svg>
);

